module.exports = __webpack_public_path__ + "img/Participant.70631a47.svg";